import { useAppModals, useAuth } from '@hb/react'
import { useEffect } from 'react'
import { DefaultModal } from '../Modals/DefaultModal'
import { SignInContent } from './SignInContent'

export const SignInModal = () => {
  const { openId, close } = useAppModals(s => s.signIn)
  const authUser = useAuth(s => s.authUser)
  useEffect(() => {
    if (authUser) close()
  }, [authUser, close])

  return (
    <DefaultModal
      isCentered
      overlayHeader
      render={() => <SignInContent onClose={close} />}
      isOpen={openId === 'root'}
      onClose={close}
    />
  )
}
